import React, { useState, useEffect } from "react";
import { ArrowRight } from "lucide-react";
import api from "@/lib/api";
import { Loading, Empty, SectionHeader, Card, fmtDate } from "./shared";
import { SelectableTable, SelectAllHeaderCheckbox, RowCheckbox } from "@/components/admin/SelectableTable";

const STATUS_COLORS = {
  active: "bg-emerald-100 text-emerald-700", pending: "bg-amber-100 text-amber-700",
  declined: "bg-red-100 text-red-700", removed: "bg-slate-100 text-slate-500",
};
const STATUS_LABEL = { active: "Actif", pending: "En attente", declined: "Refusé", removed: "Retiré" };

export default function AdminPartnerships() {
  const [items, setItems] = useState(null);
  useEffect(() => { api.get("/admin/partnerships").then((r) => setItems(r.data.partnerships || [])).catch(() => setItems([])); }, []);
  if (items === null) return <Loading />;
  return (
    <div data-testid="admin-partnerships">
      <SectionHeader title="Partner Relationships" subtitle="Toutes les relations entre organisations (lecture seule)." />
      {items.length === 0 ? <Empty label="Aucun partenariat." testid="partnerships-empty" /> : (
        <Card>
          <SelectableTable rows={items} rowId={(p) => p.id} filename="adminpartnerships.csv" ariaLabel="Tableau — sélection et défilement">
            <table className="w-full min-w-[640px]">
              <thead><tr className="border-b border-slate-200 bg-slate-50 text-left text-xs font-semibold uppercase tracking-wider text-slate-500"><th className="px-3 py-2"><SelectAllHeaderCheckbox /></th>
                <th className="px-5 py-3">Relation</th><th className="px-5 py-3">Statut</th><th className="px-5 py-3">Créé le</th>
              </tr></thead>
              <tbody>
                {items.map((p) => (
                  <tr key={p.id} data-testid={`partnership-row-${p.id}`} className="border-b border-slate-100 last:border-0"><td className="px-3 py-2"><RowCheckbox id={p.id} /></td>
                    <td className="px-5 py-3 text-sm text-[#17201A]">
                      <span className="font-medium">{p.org_a}</span>
                      <ArrowRight size={13} className="mx-2 inline text-slate-300" />
                      <span className="font-medium">{p.org_b}</span>
                    </td>
                    <td className="px-5 py-3">
                      <span className={`inline-flex rounded-full px-2 py-0.5 text-xs font-semibold ${STATUS_COLORS[p.status] || STATUS_COLORS.removed}`}>{STATUS_LABEL[p.status] || p.status}</span>
                    </td>
                    <td className="px-5 py-3 text-xs text-slate-500">{fmtDate(p.created_at)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </SelectableTable>
        </Card>
      )}
    </div>
  );
}
